// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_inputContainer__eWoqa {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 16px;
  padding: 0;
}

.styles_bottomContainer__3vKdh {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.styles_bottomContainer__3vKdh .styles_forgotPassword__gOmBH {
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #0250ee;
  text-decoration: none;
  cursor: pointer;
}
.styles_bottomContainer__3vKdh .styles_signinBtn__ZwzsR {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: #0250ee;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #fff;
  gap: 5px;
}
.styles_bottomContainer__3vKdh .styles_signinBtn__ZwzsR:hover {
  background-color: #0250ee;
  opacity: 0.8;
}
.styles_bottomContainer__3vKdh .styles_signinBtn__ZwzsR:disabled {
  opacity: 0.5;
  color: #fff;
}
.styles_bottomContainer__3vKdh .styles_loadingBtn__z4nb6 {
  pointer-events: none;
  opacity: 0.5;
  color: #fff;
}

.styles_loadingContainer__rSylX {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: Poppins;
  font-size: 18px;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/pages/Auth/Login/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;AAAE;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AAEJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AAEJ;AADI;EACE,yBAAA;EACA,YAAA;AAGN;AADI;EACE,YAAA;EACA,WAAA;AAGN;AACE;EACE,oBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,WAAA;AAAF","sourcesContent":[".inputContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n  gap: 16px;\n  padding: 0;\n}\n\n.bottomContainer {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .forgotPassword {\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.71;\n    letter-spacing: normal;\n    color: #0250ee;\n    text-decoration: none;\n    cursor: pointer;\n  }\n  .signinBtn {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 8px 16px;\n    border-radius: 4px;\n    background-color: #0250ee;\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.71;\n    letter-spacing: normal;\n    color: #fff;\n    gap: 5px;\n    &:hover {\n      background-color: #0250ee;\n      opacity: 0.8;\n    }\n    &:disabled {\n      opacity: 0.5;\n      color: #fff;\n    }\n  }\n\n  .loadingBtn {\n    pointer-events: none;\n    opacity: 0.5;\n    color: #fff;\n  }\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  font-family: Poppins;\n  font-size: 18px;\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `styles_inputContainer__eWoqa`,
	"bottomContainer": `styles_bottomContainer__3vKdh`,
	"forgotPassword": `styles_forgotPassword__gOmBH`,
	"signinBtn": `styles_signinBtn__ZwzsR`,
	"loadingBtn": `styles_loadingBtn__z4nb6`,
	"loadingContainer": `styles_loadingContainer__rSylX`
};
export default ___CSS_LOADER_EXPORT___;
